import { REGEX } from "./regex";
import { VALIDATION_MESSAGES } from "./validationMessages";

export const validateField = ({
  label,
  value,
  required,
  type,
  minLength,
  maxLength,
  matchValue,
  customValidator,
}) => {
  const trimmed =
    typeof value === "string"
      ? value.trim()
      : value;

  if (
    required &&
    (!trimmed ||
      trimmed.length === 0)
  ) {
    return VALIDATION_MESSAGES.required(
      label
    );
  }

  if (!trimmed) {
    return "";
  }

  if (
    minLength &&
    trimmed.length < minLength
  ) {
    return VALIDATION_MESSAGES.minLength(
      label,
      minLength
    );
  }

  if (
    maxLength &&
    trimmed.length > maxLength
  ) {
    return VALIDATION_MESSAGES.maxLength(
      label,
      maxLength
    );
  }

  if (
    type &&
    REGEX[type] &&
    !REGEX[type].test(trimmed)
  ) {
    return type === "PASSWORD"
      ? VALIDATION_MESSAGES.passwordFormat
      : VALIDATION_MESSAGES.invalid(label);
  }

  if (
    matchValue !== undefined &&
    trimmed !== matchValue
  ) {
    return `${label} does not match`;
  }

  if (
    customValidator &&
    typeof customValidator ===
    "function"
  ) {
    return (
      customValidator(trimmed) || ""
    );
  }

  return "";
};